import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostMastersDownload } from '../../../api/masters/masters';
import { useOptionsForBinary } from '../../../hooks/api';
import { executeDownload } from '../../../utils/download';
import BlobErrorModal from '../../modules/BlobErrorModal';
import SpinnerModal from '../../modules/SpinnerModal';
import { MastersSearchConditions } from '../../../api/model';

type Props = {
  conditions: MastersSearchConditions;
};

function MasterListDownload({ conditions }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  // スピナーモーダルを表示する
  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);

  // エラーダイアログ
  const [displayDownloadError, setDisplayDownloadError] = useState(false);

  const optionsForBinary = useOptionsForBinary(language);
  const {
    mutateAsync: _downloadAsync,
    isError: downloadIsError,
    error: downloadError,
  } = usePostMastersDownload<AxiosError<Blob>>(optionsForBinary);

  useEffect(() => {
    setDisplayDownloadError(downloadIsError);
  }, [downloadIsError]);

  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    const response = await _downloadAsync({data: conditions});
    if (response.status === 200) {
      executeDownload(response);
      setDisplaySpinnerModal(false);
    } else {
      setDisplaySpinnerModal(false);
    }
  }, [_downloadAsync, conditions]);

  return (
    <>
    <a href="#download" onClick={() => downloadAsync()}>
      <i className="fa-solid fa-download" />
      {t('ダウンロード')}
    </a>
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && (
        <BlobErrorModal error={downloadError} onClickOk={() => setDisplayDownloadError(false)} />
      )}
    </>
  );
}

export { MasterListDownload };
